import React from 'react';
import { useEffect} from "react";
import HomeFooterComponent from '../common/footer/homefooter/HomeFooterView';
// import DashboardHeaderComponent from '../common/header/dashboard-header/DashboardHeaderComponent';
import DashboardHeaderComponent from "../common/header/homeheader/HomeHeaderComponent";
import SideHeaderComponent from '../common/header/side-header/SideHeaderComponent';

function DashboardLayout(props) {

    useEffect(() => {

      const header = document.getElementById("myHeader");
      const sticky = header.offsetTop;
      const scrollCallBack = window.addEventListener("scroll", () => {
        if (window.pageYOffset > sticky) {
          header.classList.add("dashboard__sticky");
        } else {
          header.classList.remove("dashboard__sticky");
        }
      });
      return () => {
        window.removeEventListener("scroll", scrollCallBack);
      };
    }, []);
  
    return (
      <div>
        <header id="myHeader" className="dashboard__header">
        <DashboardHeaderComponent  />
        </header>
        <div className='inner-body-section user-dashboard-main-body'>
        <SideHeaderComponent />
                     {props.children}
                 </div>
        {/* <HomeFooterComponent /> */}
      </div>
    );
  }
  
  export default DashboardLayout;
  
